import styled from 'styled-components';
import { TextStyle } from 'components/text';
import { FontSize, FontWeight, device, spacing } from 'commons';

const { height, borderRadius } = spacing.input;

export const DateInputWrapper = styled.div`
  min-width: 315px;
  height: ${height};
  border: 1px solid ${({ theme }) => theme.neutral_900};
  border-radius: ${borderRadius};
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  @media (max-width: ${device.mobile}px) {
    min-width: auto;
    padding: 8px;
    gap: 4px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  strong {
    font-weight: ${FontWeight.bold};
  }

  @media (max-width: ${device.mobile}px) {
    gap: 4px;

    ${TextStyle} {
      font-size: ${FontSize.font12};
    }
  }
`;

export const ArrowDownContainer = styled.div<{ $isDatePickerOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transform: rotate(
      ${({ $isDatePickerOpen }) => ($isDatePickerOpen ? '180deg' : '0deg')}
    );
    transition: transform 0.2s ease-in-out;
  }
`;
